import { render, staticRenderFns } from "./CatalogueBanner.vue?vue&type=template&id=c6dd03fe&scoped=true&"
import script from "./CatalogueBanner.vue?vue&type=script&lang=js&"
export * from "./CatalogueBanner.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueBanner.vue?vue&type=style&index=0&id=c6dd03fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dd03fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCarousel,VCarouselItem,VContainer,VImg})
